import dayjs from 'dayjs';
import { useDynamicPageFiltersStore } from '@/stores/dynamicPageFiltersStore';
import { useMainStore } from '@/stores/mainStore';

export async function fetchMenus({ pageQuery, selectedFilter, api }) {
  try {
    const mainStore = useMainStore();
    const pageQueryFilter = pageQuery.filter;
    const reqQuery = { query_id: pageQueryFilter || selectedFilter };
    const { url, params } = mainStore.getDiningApi(api.defaults.baseURL);
    const response = await api.get(url, {
      params: {
        ...params,
        ...reqQuery,
      },
      cache: { ignoreCache: false },
    });
    const {
      menus,
      meta: { links },
    } = response.data;
    return {
      menus,
      selectedFilter: pageQueryFilter,
      links,
    };
  } catch {
    throw new Error('error fetching menus');
  }
}

export async function fetchFiltersAndDisclaimer({ pageQuery = {}, api }) {
  const mainStore = useMainStore();
  const dynamicPageFiltersStore = useDynamicPageFiltersStore();
  const { url, params } = mainStore.getDiningApi(api.defaults.baseURL);

  mainStore.setCustomSectionData({ type: 'menus', fallbackSectionName: 'Dining' });

  try {
    const diningApiResponse = await api.get(url, { params, cache: { ignoreCache: false } });
    const {
      meta: { queries: diningFilters, disclaimer },
    } = diningApiResponse.data;
    const defaultFilter = diningFilters.find(({ name }) => name.toUpperCase() === 'THIS WEEK') || diningFilters[0];

    dynamicPageFiltersStore.setDynamicPageFilters({
      type: 'dining',
      filters: diningFilters,
    });
    mainStore.setDiningDisclaimer(disclaimer);

    const selectedFilter = pageQuery.filter || defaultFilter.id;

    const menus = await fetchMenus({
      pageQuery,
      selectedFilter,
      api,
    });
    return {
      selectedFilter,
      menus: menus.menus,
      links: menus.links,
    };
  } catch {
    throw new Error('error fetching filters and disclaimer');
  }
}

export function formatDate(date) {
  return dayjs(date).format('dddd, MMM D');
}
